<template>
  <div class="checkbox-group-edit-modal">
    <div class="modalHeader" style="border-radius: 9px 9px 0px 0px !important;">
      <span class="title">Manage Widgets</span>
      <span @click="$emit('close')" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <div class="form-group">
        <label class="font14"><b>Widget:</b></label>
        <search-select
          :options="widgets"
          v-model="currentWidget"
          @input="changeWidget"
        />
      </div>
      <div class="form-group">
        <label class="font14"><b>Widget Label:</b></label>
        <textarea
          class="form-control"
          v-model="widgetLabel"
        />
      </div>

      <div class="float-right">
        <button
          class="btn btn-success"
          @click="setWidgetData"
          v-if="currentWidget !== null"
        >Save</button>

        <button
          class="btn btn-secondary"
          @click="$emit('close')"
        >Close</button>
      </div>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'

  export default {
    name: 'widget-labels-modal',

    data () {
      return {
        currentWidget: {},
        widgetLabel: '',
        maxItems: '',
        widgets: [
          {
            label: 'Names',
            value: 'names'
          },
          {
            label: 'Email',
            value: 'email'
          },
          {
            label: 'Biographic',
            value: 'biographic'
          },
          {
            label: 'Additional',
            value: 'additional'
          },
          {
            label: 'Immigration',
            value: 'immigration'
          },
          {
            label: 'Visa Petitions',
            value: 'visaPetitions'
          },
          {
            label: 'Addresses',
            value: 'addresses'
          },
          {
            label: 'Previous Addresses',
            value: 'previousAddresses'
          },
          {
            label: 'Phones',
            value: 'phones'
          },
          {
            label: 'Jobs',
            value: 'jobs'
          },
          {
            label: 'Educational History',
            value: 'educationalHistory'
          },
          {
            label: 'Criminal History',
            value: 'criminalHistory'
          },
          {
            label: 'Work Permit',
            value: 'eads'
          },
          {
            label: 'Passport',
            value: 'passport'
          },
          {
            label: 'Travel History',
            value: 'travelHistory'
          },
          {
            label: 'US Entries',
            value: 'usEntries'
          },
          {
            label: 'Visa History',
            value: 'visaHistory'
          },
          {
            label: 'Marriage History',
            value: 'marriageHistory'
          },
          {
            label: 'Family Members',
            value: 'familyMembers'
          },
          {
            label: 'Advance Parole',
            value: 'advanceParole'
          }
        ]
      }
    },

    components: {
      vSelect
    },

    mounted () {
      this.currentWidget = this.widgets[0]

      let currentTemplate = this.$store.state.templates[this.$store.state.currentTemplateName]

      if (currentTemplate.widgetLabels !== undefined && currentTemplate.widgetLabels !== null) {
        if (currentTemplate.widgetLabels[this.currentWidget.value] !== undefined) {
          this.widgetLabel = currentTemplate.widgetLabels[this.currentWidget.value].label !== undefined ? currentTemplate.widgetLabels[this.currentWidget.value].label : ''
        }
      }
    },

    methods: {
      setWidgetData () {
        let currentTemplate = this.$store.state.templates[this.$store.state.currentTemplateName]

        if (currentTemplate.widgetLabels === undefined || currentTemplate.widgetLabels === null) currentTemplate.widgetLabels = {}

        currentTemplate.widgetLabels[this.currentWidget.value] = {
          label: this.widgetLabel
        }

        this.$store.commit('setCurrentTemplateData', currentTemplate)

        setTimeout(() => {
          this.$store.dispatch('saveTemplate')

          this.$emit('close')
        }, 300)
      },

      changeWidget () {
        let currentTemplate = this.$store.state.templates[this.$store.state.currentTemplateName]

        if (currentTemplate.widgetLabels !== undefined && currentTemplate.widgetLabels !== null) {
          if (currentTemplate.widgetLabels[this.currentWidget.value] !== undefined) {
            this.widgetLabel = currentTemplate.widgetLabels[this.currentWidget.value].label !== undefined ? currentTemplate.widgetLabels[this.currentWidget.value].label : ''
          } else this.widgetLabel = ''
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .checkbox-group-edit-modal {
    position: fixed;
    top: 10%;
    left: 50%;
    width: 90%;
    max-width: 1000px;
    min-height: 480px;
    max-height: 90%;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    z-index: 100;
    transform: translate(-50%);

    .modalHeader {
      background-color: #2d5f8b;
      color: #FFF;
      font-size: 18px;
      padding: 5px 10px 5px 10px;
      height: 37px;
    }

    .btn-close {
      cursor: pointer;
      color: #FFF;
    }

    .modalBody {
      position: absolute;
      padding: 10px;
      width: 100%;
      height: calc(100% - 37px);
      overflow-y: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/questionnaires/WidgetLabelsModal.vue